import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Honeybadger from 'honeybadger-js'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import { useSessionContext } from 'hooks/SessionContext'
import { useServerErrorContext } from 'hooks/ServerErrorContext'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'
import Api from 'services/api'

const ImpersonationBanner = () => {
  const { session: { id, isImpersonating, dealerId, dealerName }, setSession } = useSessionContext()
  const { setServerError } = useServerErrorContext()

  const navigate = useNavigate()

  const [isCancelImpersonationInProgress, setIsCancelImpersonationInProgress] = useState(false)

  const onCancelImpersonation = useCallback(async () => {
    setIsCancelImpersonationInProgress(true)

    await Api.Session.update({ impersonateDealerId: null })
      .then((res) => {
        navigate('/admin/dealers')
        setSession(res)
      })
      .catch(() => {
        Honeybadger.notify('Error canceling impersonate user', { context: { id, isImpersonating, dealerId, dealerName } })
        setServerError('Error canceling impersonate user')
      })
      .finally(() => {
        setIsCancelImpersonationInProgress(false)
      })
  }, [dealerName, navigate, id, dealerId, isImpersonating, setServerError, setSession])

  return (
    <>
      {isImpersonating && (
        <S.Container>
          <S.ExclamationSignIcon className="icon-exclamation-sign" />
          <S.Title>{`Impersonating ${dealerName || (`Unknown Dealer  ${dealerId}`)}`}</S.Title>

          <Button decoration="secondary" enabled={!isCancelImpersonationInProgress} text="Cancel" onPress={onCancelImpersonation} />
        </S.Container>
      )}
    </>
  )
}

export default ImpersonationBanner

const S = {
  Container: styled.div`
    padding: 20px;
    display: flex;
    background: ${color('impersonationBannerBackground')};
  `,
  ExclamationSignIcon: styled.i`
    margin-right: 20px;
    font-size: 29px;
    color: ${color('headerText')};

    @media ${screenSize.small} {
      margin-right: 10px;
    }
  `,
  Title: styled.h1`
    display: inline-block;
    width: calc(100% - 140px);
    margin: 0;
    color: ${color('headerText')};
    vertical-align: bottom;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;
    font-weight: bold;

    @media ${screenSize.small} {
      font-size: 22px;
      white-space: unset;
      overflow: unset;
      text-overflow: unset;
    }
  `
}
